var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFcOther({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 48.5,
    r: 3.5,
    fill: "#0088E7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 48.5,
    r: 3.5,
    fill: "#0088E7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 48.5,
    r: 3.5,
    fill: "#0088E7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 48.5,
    r: 3.5,
    fill: "#0088E7"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 33.5,
    r: 3.5,
    fill: "#0088E7"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 33.5,
    r: 3.5,
    fill: "#0088E7"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 33.5,
    r: 3.5,
    fill: "#0088E7"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 33.5,
    r: 3.5,
    fill: "#0088E7"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 18.5,
    r: 3.5,
    fill: "#0088E7"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 3.5,
    fill: "#0088E7"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 18.5,
    r: 3.5,
    fill: "#0088E7"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 18.5,
    r: 3.5,
    fill: "#0088E7"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    fill: "#0088E7"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 3.5,
    r: 3.5,
    fill: "#0088E7"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 3.5,
    r: 3.5,
    fill: "#0088E7"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 3.5,
    r: 3.5,
    fill: "#0088E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFcOther);
export default __webpack_public_path__ + "static/media/fc-other.c557d7aeb2be10a1355c77bad5888cb5.svg";
export { ForwardRef as ReactComponent };